<script setup lang="ts">
import UIHeader from '@/components/ui/UIHeader.vue'
import UIModal, {
  UIModalBody,
  UIModalFooter,
  UIModalSubmitButton
} from '@/components/ui/UIModal'
import { IEventDetails, useAnalytics } from '@/composables/useAnalytics'
import useLanguage from '@/composables/useLanguage'
import { onMounted } from 'vue'

const i18n = useLanguage('InvalidVersionModal')
const { trackEvent, trackButtonClick } = useAnalytics()

const analyticsLocation = 'reload_modal'

const onClickReload = () => {
  trackButtonClick({ action: 'reloaded_app', location: analyticsLocation })
  location.reload()
}

onMounted(() => {
  const eventDetails: IEventDetails = {
    object: 'modal',
    event: 'view',
    action: 'viewed_reload_modal',
    location: analyticsLocation
  }
  trackEvent(eventDetails)
})
</script>

<template>
  <UIModal
    label-id="invalid-version-header"
    description-id="invalid-version-description"
  >
    <UIHeader
      id="invalid-version-header"
      :text="i18n.reloadRequired"
      variant="warn"
    />
    <UIModalBody variant="coloredHeader">
      <div id="invalid-version-description" class="visible-hyperlinks">
        {{ i18n.modalBody }}
        <a href="https://updates.la.livinginfrastructure.org" target="_blank">{{
          i18n.latestFeaturesLink
        }}</a
        >.
      </div>
    </UIModalBody>
    <UIModalFooter>
      <UIModalSubmitButton
        :text="i18n.reload"
        variant="filled"
        color="warning"
        icon="Refresh"
        @click="onClickReload"
      />
    </UIModalFooter>
  </UIModal>
</template>
